// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uploader {
  width: 100%;
  height: fit-content;
}
.uploader.disabled .drop-area {
  color: var(--disabled-font-color);
  background-color: var(--disabled-bg-color);
  border-color: var(--disabled-border-color);
  cursor: default;
}
.uploader .upload-button {
  padding: 4px 16px;
  min-height: 32px;
  background-color: var(--white-color-lightest);
}
.uploader .drop-area {
  border: 2px dashed var(--border-color);
  border-radius: 10px;
  padding: 20px;
  width: 100%;
  text-align: center;
  background-color: var(--input-bg-color);
  color: var(--font_active_sub_color);
}
.uploader .file-item {
  display: flex;
  justify-content: center;
  align-items: center;
}
.uploader .file-preview-wrapper {
  width: fit-content;
  height: fit-content;
  position: relative;
}
.uploader .file-preview {
  width: fit-content;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.uploader .file-preview:hover .file-info {
  opacity: 1;
}
.uploader .file-info {
  opacity: 0;
  transition: opacity 0.2s;
  position: absolute;
  bottom: 0;
  width: 100%;
  margin: auto;
  height: 48px;
  font-size: var(--text-size-small);
  text-overflow: ellipsis;
  background: linear-gradient(to top, var(--dark-color-dark-transparent-75), transparent);
  color: var(--white-color-lightest);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 4px;
}
.uploader .remove-button {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 20px;
  height: 20px;
  max-width: 20px;
  max-height: 20px;
  min-width: 20px;
  min-height: 20px;
  border-radius: 16px;
}
.uploader .thumbnail-file {
  width: 120px;
  height: 120px;
  background-color: var(--dark-color-dark-transparent-10);
  border-radius: 8px;
  box-sizing: border-box;
}
.uploader .thumbnail-image {
  display: block;
  width: auto;
  height: 100%;
  object-fit: cover;
  background-color: var(--white-color-lightest);
}
.uploader .thumbnail-video {
  display: block;
  width: auto;
  height: 100%;
  background-color: var(--white-color-lightest);
}
.uploader .info-base {
  color: var(--primary-color-dark);
  background-color: var(--primary-color-main-transparent-25);
}
.uploader.minimum {
  padding: none;
  position: relative;
}
.uploader.minimum .drop-area {
  border: none;
  padding: 0 0;
  width: 100%;
  text-align: center;
  background-color: transparent;
  color: var(--font_active_sub_color);
}
.uploader.minimum .uploader-error {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  width: max-content;
  max-width: 320px;
  text-align: left;
  z-index: var(--z-index-local-over-1);
}
.uploader.disabled .upload-button {
  pointer-events: none;
}
.uploader.disabled .drop-area {
  pointer-events: none;
}
.uploader.disabled .remove-button {
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Uploader.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,mBAAA;AACF;AAII;EACE,iCAAA;EACA,0CAAA;EACA,0CAAA;EACA,eAAA;AAFN;AAME;EACE,iBAAA;EACA,gBAAA;EACA,6CAAA;AAJJ;AAOE;EACE,sCAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,uCAAA;EACA,mCAAA;AALJ;AAQE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AANJ;AASE;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;AAPJ;AAUE;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AARJ;AAWM;EACE,UAAA;AATR;AAcE;EACE,UAAA;EACA,wBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,iCAAA;EAEA,uBAAA;EACA,uFAAA;EACA,kCAAA;EAEA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAdJ;AAiBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EAEA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAhBJ;AAmBE;EACE,YAAA;EACA,aAAA;EACA,uDAAA;EACA,kBAAA;EACA,sBAAA;AAjBJ;AAoBE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,6CAAA;AAlBJ;AAqBE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,6CAAA;AAnBJ;AAsBE;EAGE,gCAAA;EACF,0DAAA;AAtBF;AAyBE;EACE,aAAA;EACA,kBAAA;AAvBJ;AAyBI;EACE,YAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,mCAAA;AAvBN;AA2BI;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;AAzBN;AA8BI;EACE,oBAAA;AA5BN;AA8BI;EACE,oBAAA;AA5BN;AA8BI;EACE,oBAAA;AA5BN","sourcesContent":[".uploader {\r\n  width: 100%;\r\n  height: fit-content;\r\n\r\n  // 非活性時はTextInputの:disabledと同じ色に揃える\r\n  // ドロップ領域はdivのため、カーソルでも受け付けないことを示す\r\n  &.disabled {\r\n    .drop-area {\r\n      color: var(--disabled-font-color);\r\n      background-color: var(--disabled-bg-color);\r\n      border-color: var(--disabled-border-color);\r\n      cursor: default;\r\n    }\r\n  }\r\n\r\n  .upload-button{\r\n    padding: 4px 16px;\r\n    min-height: 32px;\r\n    background-color: var(--white-color-lightest)\r\n  }\r\n\r\n  .drop-area{\r\n    border: 2px dashed var(--border-color);\r\n    border-radius: 10px;\r\n    padding: 20px;\r\n    width: 100%;\r\n    text-align: center;\r\n    background-color: var(--input-bg-color);\r\n    color: var(--font_active_sub_color);\r\n  }\r\n\r\n  .file-item {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  \r\n  .file-preview-wrapper{\r\n    width: fit-content;\r\n    height: fit-content;\r\n    position: relative;\r\n  }\r\n\r\n  .file-preview {\r\n    width: fit-content;\r\n    height: 120px;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    position: relative;\r\n\r\n    &:hover{\r\n      .file-info{\r\n        opacity: 1;\r\n      }\r\n    }\r\n  }\r\n  \r\n  .file-info{\r\n    opacity: 0;\r\n    transition: opacity 0.2s;\r\n    position: absolute;\r\n    bottom: 0;\r\n    width: 100%;\r\n    margin: auto;\r\n    height: 48px;\r\n    font-size: var(--text-size-small);\r\n    // white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    background: linear-gradient(to top, var(--dark-color-dark-transparent-75), transparent);\r\n    color: var(--white-color-lightest);\r\n    \r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    padding-bottom: 4px;\r\n  }\r\n\r\n  .remove-button{\r\n    position: absolute;\r\n    top: -6px;\r\n    right: -6px;\r\n\r\n    width: 20px;\r\n    height: 20px;\r\n    max-width: 20px;\r\n    max-height: 20px;\r\n    min-width: 20px;\r\n    min-height: 20px;\r\n    border-radius: 16px;\r\n  }\r\n\r\n  .thumbnail-file {\r\n    width: 120px;\r\n    height: 120px;\r\n    background-color: var(--dark-color-dark-transparent-10);\r\n    border-radius: 8px;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .thumbnail-image {\r\n    display: block;\r\n    width: auto;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    background-color: var(--white-color-lightest);\r\n  }\r\n  \r\n  .thumbnail-video {\r\n    display: block;\r\n    width: auto;\r\n    height: 100%;\r\n    background-color: var(--white-color-lightest);\r\n  }\r\n\r\n  .info-base{\r\n    // background-color: var(--dark-color-dark-transparent-10);\r\n\r\n    color: var(--primary-color-dark);\r\n\t\tbackground-color: var(--primary-color-main-transparent-25);\r\n  }\r\n\r\n  &.minimum {\r\n    padding: none;\r\n    position: relative;\r\n\r\n    .drop-area{\r\n      border: none;\r\n      padding: 0 0;\r\n      width: 100%;\r\n      text-align: center;\r\n      background-color: transparent;\r\n      color: var(--font_active_sub_color);\r\n    }\r\n\r\n    // ボタンのみの表示のため、エラーは配置の流れから外して重ねる(周囲のレイアウトを押し広げないため)\r\n    .uploader-error {\r\n      position: absolute;\r\n      top: 100%;\r\n      right: 0;\r\n      margin-top: 8px;\r\n      width: max-content;\r\n      max-width: 320px;\r\n      text-align: left;\r\n      z-index: var(--z-index-local-over-1);\r\n    }\r\n  }\r\n\r\n  &.disabled{\r\n    .upload-button{\r\n      pointer-events: none;\r\n    }\r\n    .drop-area{\r\n      pointer-events: none;\r\n    }\r\n    .remove-button{\r\n      pointer-events: none;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
